import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
   selector: 'app-dashboard-card',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './dashboard-card.component.html',
   styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent {
   @Input() title = '';
   @Input() subtitle: string | null = null;
   @Input() icon: string | null = null;
   @Input() featured = false;
}
